import { useQuery } from "@tanstack/react-query";
import { getCountriesForSelect } from "../../api/apiCountries";
import i18next from "i18next";

const useGetCountriesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["CountriesForSelect", i18next.language],
        queryFn: getCountriesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetCountriesForSelect;
